import { BinaryWriter } from "../binary.js";
import { ClientOp } from "../opcodes.js";
export function encodeLook(packet, writer = new BinaryWriter(8)) {
    writer
        .u8(ClientOp.Look)
        .u16(packet.x)
        .u16(packet.y)
        .u8(packet.z)
        .u8(packet.stackIndex);
    return writer;
}
export function decodeLook(reader) {
    return { x: reader.u16(), y: reader.u16(), z: reader.u8(), stackIndex: reader.u8() };
}
export function encodeUseTile(packet, writer = new BinaryWriter(8)) {
    writer.u8(ClientOp.UseTile).u16(packet.x).u16(packet.y).u8(packet.z);
    return writer;
}
export function decodeUseTile(reader) {
    return { x: reader.u16(), y: reader.u16(), z: reader.u8() };
}
//# sourceMappingURL=world-action.js.map